
(function () {
  var doc = document, root = doc.documentElement, win = window;
  if (root.__lpStandard) return;
  root.__lpStandard = true;
  var doc = document, root = doc.documentElement, win = window;
  if (root.__lpInit) return;
  root.__lpInit = true;
  var q = function (s, c) { return (c || doc).querySelector(s); };
  var qa = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var shown = function (el) {
    if (!el) return false;
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) { if (n.getAttribute('data-visible') === 'false') return false; }
    return true;
  };
  var store = function (area, k, v) {
    try {
      var s = area === 'session' ? win.sessionStorage : win.localStorage;
      if (v === undefined) return s.getItem(k);
      if (v === null) s.removeItem(k); else s.setItem(k, v);
    } catch (e) {}
    return null;
  };
  var swap = function (el, add, remove) { if (!el) return; el.classList.remove.apply(el.classList, remove); el.classList.add.apply(el.classList, add); };
  var display = function (el, on) { swap(el, [on ? 'flex' : 'hidden'], [on ? 'hidden' : 'flex']); };
  var reduced = !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var UI = { popup: false, legal: false };
  var trap = function (panel, e) {
    if (e.key !== 'Tab' || !panel) return;
    var f = qa('button:not([disabled]), a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])', panel).filter(function (x) { return x.getClientRects().length > 0; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && doc.activeElement === last) { first.focus(); e.preventDefault(); }
  };

  var LOCALE = root.getAttribute('lang') || 'en';
  var nf = new Intl.NumberFormat(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var priceEl = q('[data-sticky-price]');
  var priceTpl = (priceEl && priceEl.getAttribute('data-money-fmt')) || '${v}';
  var money = function (v) { return priceTpl.replace('{v}', nf.format(v)); };

  var tierState = null;
  root.addEventListener('lp:tier', function (e) { tierState = e.detail; });

  var chrome = (function () {
    var bar = doc.querySelector('[data-sticky-atc]');
    var sync = function () {
      if (!bar) return;
      var blocked = UI.popup || UI.legal || win.__lpCartOpen;
      if (blocked) { bar.hidden = true; bar.classList.remove('flex'); }
      root.style.setProperty('--atc-h', bar.hidden ? '0px' : Math.round(bar.getBoundingClientRect().height) + 'px');
    };
    return { sync: sync };
  })();

  var legal = (function () {
    var active = null, last = null;
    var close = function () {
      if (!active) return;
      display(active, false);
      active = null;
      UI.legal = false;
      chrome.sync();
      if (last && last.focus) last.focus();
    };
    var open = function (m) {
      if (!m || !shown(m)) return;
      if (active) close();
      last = doc.activeElement;
      display(m, true);
      active = m;
      UI.legal = true;
      chrome.sync();
      var x = q('[data-legal-close]', m);
      if (x) x.focus();
    };
    qa('a[data-legal-popup]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = (a.getAttribute('href') || '').trim();
        if (href && href !== '#') return;
        e.preventDefault();
        open(doc.getElementById(a.getAttribute('data-legal-popup')));
      });
    });
    qa('[data-legal-close]').forEach(function (b) { b.addEventListener('click', close); });
    qa('[data-legal-modal]').forEach(function (m) { m.addEventListener('click', function (e) { if (e.target === m) close(); }); });
    doc.addEventListener('keydown', function (e) {
      if (!active) return;
      if (e.key === 'Escape') { close(); e.stopImmediatePropagation(); return; }
      trap(q('[data-legal-panel]', active), e);
    });
    return { isOpen: function () { return !!active; } };
  })();

  var toasts = (function () {
    var host = q('[data-notify]');
    if (!host) return null;
    var items = qa('[data-toast-item]', host).filter(shown);
    if (!items.length) return null;
    var KEY = 'lp_notify_state', st = { shown: 0, stopped: false, next: 0 };
    try { var raw = JSON.parse(store('session', KEY) || '{}'); st.shown = raw.shown || 0; st.stopped = !!raw.stopped; st.next = raw.next || 0; } catch (e) {}
    var save = function () { store('session', KEY, JSON.stringify(st)); };
    var MAX = 4, slow = win.innerWidth < 768 ? 2 : 1, timer = 0, hideTimer = 0, current = null, due = Date.now() + 22000;
    var paused = function () { return doc.hidden || UI.popup || UI.legal || win.__lpCartOpen; };
    var hide = function () { if (!current) return; display(current, false); current = null; };
    var fire = function () {
      hide();
      var el = items[st.next % items.length];
      st.next++;
      st.shown++;
      save();
      display(el, true);
      current = el;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 5000);
      due = Date.now() + (30000 + Math.floor(Math.random() * 30000)) * slow;
    };
    var stop = function () { if (timer) { clearInterval(timer); timer = 0; } };
    var tick = function () {
      if (st.stopped || st.shown >= MAX) { stop(); return; }
      if (paused()) { due += 1000; return; }
      if (!current && Date.now() >= due) fire();
    };
    var start = function () { if (!timer && !st.stopped && st.shown < MAX) timer = setInterval(tick, 1000); };
    qa('[data-toast-close]', host).forEach(function (b) { b.addEventListener('click', function () { clearTimeout(hideTimer); hide(); }); });
    doc.addEventListener('click', function (e) {
      var hit = e.target && e.target.closest ? e.target.closest('[data-cart-add],[data-buy-now]') : null;
      if (hit) { st.stopped = true; save(); hide(); stop(); }
    }, true);
    start();
    return { fire: fire, start: start, stop: stop, quiet: function () { due = Date.now() + 20000; } };
  })();

  var popup = (function () {
    var modal = doc.getElementById('email-modal');
    if (!modal || modal.__lpInit || !shown(modal)) return null;
    modal.__lpInit = true;
    var KEY = 'lp_email_popup:fbff080b111404c8', DAYS = 14, t0 = Date.now(), isOpen = false, shownThisLoad = false, deep = false, last = null;
    var panel = q('[data-email-panel]', modal), form = doc.getElementById('email-modal-form'), input = doc.getElementById('email-modal-input');
    var err = doc.getElementById('email-modal-error'), success = doc.getElementById('email-modal-success'), btn = q('[data-klaviyo-submit]', modal);
    var ph = q('[data-placeholder-source]', modal);
    if (input && ph) input.setAttribute('placeholder', ph.textContent.trim());
    var suppressed = function () { var v = store('local', KEY); if (v === 'subscribed') return true; var until = parseInt(v || '0', 10); return !!until && Date.now() < until; };
    var suppress = function (reason) { store('local', KEY, reason === 'submit' ? 'subscribed' : String(Date.now() + DAYS * 864e5)); };
    var open = function (force) {
      if (isOpen || (!force && (shownThisLoad || suppressed()))) return;
      isOpen = true;
      shownThisLoad = true;
      last = doc.activeElement;
      UI.popup = true;
      display(modal, true);
      chrome.sync();
      if (input) setTimeout(function () { input.focus(); }, 30);
    };
    var close = function (commit) {
      if (!isOpen) return;
      isOpen = false;
      UI.popup = false;
      display(modal, false);
      chrome.sync();
      if (commit) suppress('dismiss');
      if (last && last.focus) last.focus();
    };
    var x = doc.getElementById('email-modal-close');
    if (x) x.addEventListener('click', function () { close(true); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(true); });
    doc.addEventListener('keydown', function (e) {
      if (!isOpen || legal.isOpen()) return;
      if (e.key === 'Escape') { close(true); return; }
      trap(panel, e);
    });
    var wrap = doc.getElementById('email-modal-discount'), code = doc.getElementById('email-modal-code'), copy = doc.getElementById('email-modal-copy'), copyTimer = 0;
    if (copy) copy.addEventListener('click', function () {
      var c = code ? code.textContent : '';
      if (!c) return;
      var select = function () { var r = doc.createRange(); r.selectNodeContents(code); var s = win.getSelection(); s.removeAllRanges(); s.addRange(r); };
      if (!(navigator.clipboard && navigator.clipboard.writeText)) { select(); return; }
      navigator.clipboard.writeText(c).then(function () {
        var icon = q('i', copy);
        if (!icon) return;
        swap(icon, ['fa-check'], ['fa-copy']);
        clearTimeout(copyTimer);
        copyTimer = setTimeout(function () { swap(icon, ['fa-copy'], ['fa-check']); }, 1500);
      }).catch(select);
    });
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = ((input && input.value) || '').trim();
      if (!EMAIL.test(email)) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      if (btn) btn.disabled = true;
      var handle = location.pathname.split('/').filter(Boolean).pop() || '';
      fetch('/apps/lp/subscribe', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, landing_page_handle: handle }) })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (data) {
          if (!data || data.ok !== true) return Promise.reject(data);
          if (data.discount_code) {
            if (code) code.textContent = data.discount_code;
            try { doc.dispatchEvent(new CustomEvent('flunnel:cart:apply-discount', { detail: { code: data.discount_code } })); } catch (x2) {}
          } else if (wrap) wrap.hidden = true;
          display(form, false);
          if (success) success.hidden = false;
          suppress('submit');
        })
        .catch(function () { if (err) err.hidden = false; if (btn) btn.disabled = false; });
    });
    if (!suppressed() && !('ontouchstart' in win)) {
      var io = null;
      var cleanup = function () {
        doc.removeEventListener('mouseout', onOut, true);
        if (io) io.disconnect();
      };
      var onOut = function (e) {
        if (e.relatedTarget || e.clientY > 10) return;
        if (Date.now() - t0 < 30000 || !deep) return;
        open(false);
        if (isOpen) cleanup();
      };
      if ('IntersectionObserver' in win) {
        var marks = qa('[data-block-key]').filter(function (b) { return b.offsetHeight > 0; });
        var idx = marks.findIndex(function (b) { return b.getBoundingClientRect().top + win.scrollY >= root.scrollHeight * 0.4; });
        var mark = marks.length ? marks[Math.min(marks.length - 1, Math.max(0, idx))] : null;
        if (mark) {
          io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting || en.boundingClientRect.bottom < 0) deep = true; }); });
          io.observe(mark);
        } else deep = true;
      } else deep = true;
      doc.addEventListener('mouseout', onOut, true);
    }
    return { open: open, close: close };
  })();

  (function () {
    if (window.flunnel_cart_service) return;
    var wrap = q('[data-block-key="cart"]');
    if (!wrap || wrap.__lpCartInit) return;
    wrap.__lpCartInit = true;
    if (wrap.getAttribute('data-visible') === 'false') return;
    var launcher = doc.getElementById('flunnel-cart-launcher');
    var drawer = doc.getElementById('flunnel-cart-drawer');
    if (!drawer) return;
    var panel = q('aside', drawer), list = doc.getElementById('flunnel-cart-drawer-items'), empty = doc.getElementById('flunnel-cart-drawer-empty');
    var row = q('[data-cart-item]', drawer), checkout = q('[data-cart-checkout]', drawer);
    qa('[data-cart-item]', drawer).slice(1).forEach(function (extra) { extra.classList.add('hidden'); });
    var isOpen = false, last = null, hideTimer = null, HIDE_MS = 300;
    var line = { variant: '', unit: 0, pack: 1, qty: 0, name: '', base: '' };
    var render = function () {
      if (!row) return;
      var total = Math.round(line.unit * line.qty * 100) / 100;
      var v = q('[data-cart-item-variant]', row), up = q('[data-cart-item-unit-price]', row), lp = q('[data-cart-item-price]', row), qt = q('[data-cart-item-qty]', row);
      if (v) v.textContent = line.name;
      var tt = q('[data-cart-item-title]', row), ti = q('[data-cart-item-image]', row), pt = q('[data-product-title]');
      if (tt && pt) tt.textContent = pt.textContent.trim();
      if (up) up.textContent = money(line.unit);
      if (lp) lp.textContent = money(total);
      if (qt) qt.textContent = String(line.qty);
      qa('[data-cart-total]', drawer).forEach(function (el) { el.textContent = money(total); });
      qa('[data-cart-count]').forEach(function (el) { el.textContent = String(line.qty); });
    };
    var fromTier = function (d) { if (!d) return; line.variant = d.variant; line.unit = d.unit; line.pack = d.qty || 1; line.qty = d.qty || 1; line.name = d.name; line.base = d.base; };
    var showRow = function (on) {
      if (!row || !list || !empty) return;
      swap(row, [on ? 'flex' : 'hidden'], [on ? 'hidden' : 'flex']);
      if (on) list.classList.remove('hidden'); else list.classList.add('hidden');
      display(empty, !on);
    };
    var open = function () {
      if (isOpen) return;
      isOpen = true;
      win.__lpCartOpen = true;
      last = doc.activeElement;
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      display(drawer, true);
      chrome.sync();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!isOpen) return;
          drawer.classList.remove('opacity-0', 'invisible');
          if (panel) panel.classList.remove('translate-x-full', 'invisible');
        });
      });
      var x = doc.getElementById('flunnel-cart-drawer-close');
      if (x) x.focus();
    };
    var close = function () {
      if (!isOpen) return;
      isOpen = false;
      win.__lpCartOpen = false;
      drawer.classList.add('opacity-0', 'invisible');
      if (panel) panel.classList.add('translate-x-full', 'invisible');
      hideTimer = setTimeout(function () { display(drawer, false); hideTimer = null; chrome.sync(); }, HIDE_MS);
      if (last && last.focus) last.focus();
    };
    root.addEventListener('lp:tier', function (e) { fromTier(e.detail); render(); });
    fromTier(tierState);
    render();
    qa('[data-cart-open]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); showRow(true); open(); }); });
    qa('[data-cart-add]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); el.disabled = true; el.setAttribute('aria-busy', 'true'); setTimeout(function () { el.disabled = false; el.removeAttribute('aria-busy'); }, 400); fromTier(tierState); render(); showRow(true); open(); }); });
    qa('[data-cart-close]', drawer).forEach(function (el) { el.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    doc.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { close(); return; }
      trap(panel, e);
    });
    var minus = q('[data-cart-qty-minus]', drawer), plus = q('[data-cart-qty-plus]', drawer), remove = q('[data-cart-item-remove]', drawer);
    if (plus) plus.addEventListener('click', function () { line.qty = Math.min(line.pack * 99, line.qty + line.pack); render(); });
    if (minus) minus.addEventListener('click', function () { line.qty = Math.max(line.pack, line.qty - line.pack); render(); });
    if (remove) remove.addEventListener('click', function () { showRow(false); });
  })();
})();
